<template>
  <div>
    <div ref="templateData" style="width: 100%; height: 750px"></div>
  </div>
</template>

<script>
export default {
  props: { webData: Object },
  data(){
    return{
      seriesData:[],
      yAxis:[],
    }
  },
  watch: {
    webData(val, newval) {
      this.dataProcessing();
      console.log(this.webData);
    },
  },
  methods: {
    dataProcessing() {

      this.yAxis = []
      this.seriesData = []
      for (let key in this.webData.module_pv) {
    
        this.seriesData.push({
          value: this.webData.module_pv[key],
          name:key,
        });
      }
      let opicity = 0.06
      this.seriesData.sort((a,b)=>{return a.value-b.value})
      this.seriesData.forEach((item)=>{
          opicity += 0.06
         item.itemStyle={
            color: `rgba(84,112,198,${opicity})`
          }
        this.yAxis.push(item.name)
      })
      this.createEcharts();
      console.log(this.seriesData);
    },

    createEcharts() {
      var myChart = this.$echarts.init(this.$refs.templateData);
      var option;

      var labelOption = {
        show: false,
        position: "insideTopLeft",
        formatter: "{c}  {name|{a}}",
        rich: {
          name: {},
        },
      };

      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: ["各板块浏览量"],
        },
        toolbox: {
          show: true,
          left: "right",
          top: "center",
          // feature: {
          //   mark: { show: true },
          //   dataView: { show: true, readOnly: false },
          //   magicType: { show: true, type: ["line", "bar", "stack", "tiled"] },
          //   restore: { show: true },
          //   saveAsImage: { show: true }
          // }
        },
        yAxis: [
          {
            type: "value",
          },
        ],
        xAxis: [
          {
            type: "category",
            axisTick: { show: false },
            data: this.yAxis,
          },
        ],
        series: [
          {
            name: "各板块浏览量",
            type: "bar",
            barGap: 0,
            label: labelOption,
            emphasis: {
              focus: "series",
            },
            data: this.seriesData,
          },
        ],
      };

      option && myChart.setOption(option);
    },
  },
};
</script>

<style lang="scss" scope>
</style>


// WEBPACK FOOTER //
// src/components/admin/index/TemplateData.vue